import React from "react";
import Loader from "../assets/images/loader.gif";
import styled from "styled-components";

const Loaders = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;


  .wrap__loader {
    width: 300px;
    height: 300px;
  }
`


export const withLazyLoading = (Component) => {

    return (props) => {
        return (
            <React.Suspense fallback={
                <Loaders>
                    <img className='wrap__loader'
                         src={Loader}
                         alt='loading'/>
                </Loaders>
            }>
                <Component {...props}/>
            </React.Suspense>
        )
    }
}